import React from "react";
import "./Charts.css";

/**
 * Risk matrix: likelihood (rows, highest first) against impact (columns).
 *
 * Cell colour comes from the standard likelihood x impact band, not from the
 * count in the cell — the count is what the number says. The ramp keeps the
 * green-to-red risk convention while decreasing in lightness at every step, so
 * the ordering still reads in greyscale or with colour-vision deficiency.
 */
const BANDS = ["#e9f6ec", "#d8eec4", "#f7e3a8", "#f2c391", "#eda3a0"];

const bandFor = (likelihoodRank, impactRank, size) => {
  const product = likelihoodRank * impactRank;
  const max = size * size;
  return Math.min(BANDS.length - 1, Math.floor((product / max) * BANDS.length));
};

export default function HeatMap({ rowLabels, colLabels, values, rowAxis, colAxis }) {
  const size = colLabels.length;

  return (
    <div className="heat">
      <div className="heat__body">
        <span className="heat__axis heat__axis--y">{rowAxis}</span>

        <div className="heat__grid-wrap">
          <div
            className="heat__grid"
            style={{ gridTemplateColumns: `auto repeat(${size}, minmax(0, 1fr))` }}
            role="table"
            aria-label={`${rowAxis} against ${colAxis}`}
          >
            {rowLabels.map((rowLabel, rowIndex) => {
              // Rows run highest likelihood first, so rank counts back up.
              const likelihoodRank = rowLabels.length - rowIndex;
              return (
                <React.Fragment key={rowLabel}>
                  <span className="heat__row-label">{rowLabel}</span>
                  {values[rowIndex].map((value, colIndex) => (
                    <span
                      key={`${rowLabel}-${colLabels[colIndex]}`}
                      className="heat__cell"
                      style={{
                        background:
                          BANDS[bandFor(likelihoodRank, colIndex + 1, size)],
                      }}
                      title={`${rowLabel} likelihood, ${colLabels[colIndex]} impact: ${value}`}
                    >
                      {value}
                    </span>
                  ))}
                </React.Fragment>
              );
            })}

            <span />
            {colLabels.map((label) => (
              <span className="heat__col-label" key={label}>
                {label}
              </span>
            ))}
          </div>

          <p className="heat__axis heat__axis--x">{colAxis}</p>
        </div>
      </div>
    </div>
  );
}
